var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "online-service",
      style: { right: _vm.width + "px" },
      on: { mouseenter: _vm.mouseEnter, mouseleave: _vm.mouseLeave }
    },
    [
      _c("div", { staticClass: "online_icon" }, [
        _c(
          "a",
          {
            staticStyle: { display: "block", cursor: "default" },
            attrs: {
              id: "floatShow",
              href: "javascript:void(0);",
              target: "_self"
            }
          },
          [_c("img", { attrs: { src: _vm.onlineAdvisory } })]
        )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "onlineService" } }, [
        _c("h2", [_vm._v("外汇通客服中心")]),
        _vm._v(" "),
        _c("ul", [
          _c(
            "li",
            { staticClass: "li01", on: { click: _vm.onlineServiceClick } },
            [_c("img", { attrs: { src: _vm.chatIcon } }), _vm._v("在线客服")]
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("span", { staticClass: "btn" }, [
          _c("img", { attrs: { src: _vm.callIcon } }),
          _vm._v("400-099-0087")
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "code" } }, [
          _c("img", { attrs: { src: _vm.qrCode } })
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("工作日：8：30-22：30"),
      _c("br"),
      _vm._v("\n          节假日：9：00-17：00")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bb6f967", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb6f967","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/onlineService/onlineService.vue
// module id = 73
// module chunks = 0 1 2